var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "download_svg__Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 600",
    width: "1em",
    height: "1em"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".download_svg__cls-1{fill:none;stroke:#ff432b;stroke-linecap:round;stroke-linejoin:round;stroke-width:25px}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "download_svg__cls-1",
    d: "M300 43.06V383.5M451.28 234.98L300 386.26 148.72 234.98"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "download_svg__cls-1",
    d: "M557.94 369.71V492.6c0 35.53-28.81 64.34-64.34 64.34H106.4c-35.53 0-64.34-28.81-64.34-64.34V369.71"
  })));
}
export default SvgDownload;